import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    projectDetails: [],
};

const projectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        setProjectDetails: (state, action) => {
            state.projectDetails = action.payload;
        },
        clearProjectDetails: (state) => {
            state.projectDetails = [];
        },
    },
});

export const { setProjectDetails, clearProjectDetails } = projectSlice.actions;

export default projectSlice.reducer;
